import React, { useRef } from "react"

import useEmblaCarousel from "embla-carousel-react"
import Autoplay from "embla-carousel-autoplay"
import Fade from "embla-carousel-fade"

import { Grid } from "@material-ui/core"

import { Banner } from "@/utils/banner"

import BannerCarouselCard from "@/pages/Admin/Dashboard/Banners/BannersCarousel/BannerCarouselCard"

import useStyles from "@/pages/Admin/Dashboard/Banners/BannersCarousel/styles"

type BannersCarouselProps = {
	banners: Banner[]
}

const BannersCarousel: React.FC<BannersCarouselProps> = (props) => {
	const {
		banners
	} = props

	const classes = useStyles()
	const autoplay = useRef(Autoplay({ delay: 4000 }))

	const hasActiveCarousel = banners.length > 1

	const [emblaRef, emblaApi] = useEmblaCarousel({
		loop: true,
		active: hasActiveCarousel,
		align: "start"
	}, [autoplay.current, Fade()])

	const handleStopAutoplay = () => {
		if (autoplay.current && hasActiveCarousel) {
			autoplay.current.stop()
		}
	}

	const handleStartAutoplay = () => {
		if (autoplay.current && hasActiveCarousel) {
			autoplay.current.play()
		}
	}

	return (
		<Grid container direction="row">
			<Grid item xs={12}>
				<Grid
					container
					direction="column"
					xs={12}
					className={classes.emblaCarouselViewport}
					ref={emblaRef}
					onMouseEnter={handleStopAutoplay}
					onMouseLeave={handleStartAutoplay}
				>
					<Grid
						item xs={12}
						className={classes.carouselContainer}
					>
						{banners.map((banner, index) => (
							<BannerCarouselCard
								key={index}
								banner={banner}
								emblaApi={emblaApi}
								hasActiveCarrousel={hasActiveCarousel}
							/>
						))}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default BannersCarousel
